import * as React from "react";
import {default as DeleteInputAddon} from "../../ui/input/DeleteInputAddon";
import Address from "../../../model/address/Address";
import {FocusableProps} from "../../common/props/FocusableProps";
import {ClickableProps} from "../../common/props/ClickableProps";
import TextArea from "../../../hiberUiKit/src/atoms/TextArea/TextArea";

interface ComponentProps {
	/**
	 * Selected address.
	 */
	address: Address;
	/**
	 * Callback on reset.
	 */
	onReset: () => void;
}

type Props = ComponentProps & FocusableProps & ClickableProps

export default class SelectedAddressPresenter extends React.PureComponent<Props, {}> {
	render() {
		return (
			<DeleteInputAddon addonPosition={"right"} onClick={this.props.onClick} onDeleteClick={this.props.onReset}>
				<TextArea onChange={() => {}}
						  value={this.props.address.displayName()}
						  autoSize={true}
						  focus={this.props.focus}
						  hasBorder={true}
						  onFocus={this.props.onFocus}/>
			</DeleteInputAddon>
		);
	}
}

